import _extends from '@babel/runtime/helpers/esm/extends';
import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useMemo } from 'react';
import { isFunction } from '@elliemae/ds-shared/utils';
import useDataGrid from '@elliemae/ds-shared/useDataGrid';
import Table from './components/Table.js';
import TableBody from './components/TableBody.js';
import TableHeader from './components/TableHeader.js';
import { d as defaultRenderers } from './index-4a6329dc.js';
import { DatagridWrapper } from './components/renderers/defaultClassedRenderers.js';
import addOptionalFooterComponents from './components/footer/addOptionalFooterComponents.js';
import addOptionalHeaderComponents from './components/header/addOptionalHeaderComponents.js';
import { EmptyState } from './components/EmptyState.js';
import getPluginsFromProps from './utilities/getPluginsFromProps.js';
import { defaultPlugins } from './defaultPlugins.js';
import { normalizeRows } from './utilities/normalizeData.js';
import { renderRowsLoader } from './components/renderers/renderRowsLoader.js';
import './components/HeaderCell.js';
import 'prop-types';
import '@elliemae/ds-shared/createDataInstance/utils';
import '@elliemae/ds-basic/TruncatedTooltipText';
import './components/BodyCell.js';
import '@elliemae/ds-shared/FocusGroup/FocusGrid';
import './components/tableContext.js';
import '@elliemae/ds-classnames';
import './blockNames.js';
import './plugins/pagination/components/Pagination.js';
import './plugins/pagination/components/Paginator.js';
import 'react-pagify';
import 'segmentize';
import './plugins/pagination/components/PerPageDropdown.js';
import 'memoize-one';
import '@elliemae/ds-utilities/utils';
import '@elliemae/ds-basic/form/ComboBox';
import '@elliemae/ds-filterbar';
import '@elliemae/ds-basic/Grid';
import '@elliemae/ds-icons/WarningTriangle';
import '@elliemae/ds-system';
import '@elliemae/ds-basic/Button';
import 'styled-components';
import './plugins/row-dnd/DndRowsPlugin.js';
import 'react-sortable-hoc';
import '@elliemae/ds-icons/GripperVertical';
import '@elliemae/ds-shared/useDataGrid/initColumnDefinition';
import '@elliemae/ds-shared/createDataInstance/createInstancePlugin';
import './plugins/column-dnd/DndColumnsPlugin.js';
import '@elliemae/ds-utilities/system';
import './plugins/column-dnd/decorateGridWithDndColumns.js';
import './plugins/infinite-scrolling/InfiniteScrollPlugin.js';
import '@babel/runtime/helpers/esm/slicedToArray';
import '@babel/runtime/helpers/esm/asyncToGenerator';
import '@babel/runtime/regenerator';
import './plugins/editable/EditablePlugin.js';
import '@elliemae/ds-utilities/hooks/useDerivedStateFromProps';
import './plugins/editable/decorateEditable.js';
import 'react-edit';
import '@elliemae/ds-icons/EditPencil';
import './plugins/editable/getEditorComponent.js';
import './plugins/editable/EditableComponents/ComboBox.js';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import './plugins/editable/EditableComponents/TextBox.js';
import '@elliemae/ds-basic/form/TextBox';
import './plugins/sortable/SortablePlugin.js';
import 'sortabular';
import './plugins/sortable/sortHeaderFormatter.js';
import '@elliemae/ds-icons/ArrowheadDown';
import '@elliemae/ds-icons/ArrowheadUp';
import './plugins/sortable/useSortableState.js';
import 'sortabular/dist';
import './plugins/sortable/checkIfSortable.js';
import './plugins/sortable/sorter.js';
import 'moment';
import './plugins/selectable/SelectablePlugin.js';
import 'obj-str';
import './plugins/selectable/addSelectableColumn.js';
import './plugins/selectable/selectableFormatter.js';
import '@elliemae/ds-basic/form/Checkbox';
import '@elliemae/ds-basic/form/Radio';
import './plugins/selectable/useSelectableState.js';
import './plugins/selectable/helper.js';
import './plugins/filterable/FilterablePlugin.js';
import './plugins/filterable/addFilterToColumn.js';
import './plugins/filterable/filterableFormatter.js';
import './plugins/filterable/components/FilterableHeader.js';
import '@elliemae/ds-utilities/hooks/useResizeObserver';
import '@elliemae/ds-system/theme';
import './plugins/filterable/components/filterable-menus/getFilterMenuByType.js';
import './plugins/filterable/components/filterable-menus/DateRangeFilterMenu.js';
import '@elliemae/ds-date-range-picker';
import '@elliemae/ds-date-picker';
import '@elliemae/ds-basic/Popper';
import '@elliemae/ds-icons/DatePicker2';
import './plugins/filterable/components/filterable-menus/defaultDateFormat.js';
import './plugins/filterable/components/filterable-menus/SingleDateFilterMenu.js';
import './plugins/filterable/components/filterable-menus/SingleRangeSwitcherMenu.js';
import './plugins/filterable/components/filterable-menus/TextFilterMenu.js';
import 'lodash';
import '@elliemae/ds-dropdownmenu';
import '@elliemae/ds-menu';
import '@elliemae/ds-icons/SearchSmall';
import './plugins/filterable/helper.js';
import './plugins/filterable/filtering-helper/filterRowsByQuery.js';
import './plugins/filterable/filtering-helper/strategiesOperators.js';
import 'comparejs';
import './plugins/filterable/useFilterableState.js';
import 'uuid';
import './plugins/toolbar/ToolbarPlugin.js';
import './plugins/toolbar/RowRenderer.js';
import './plugins/toolbar/ToolbarTrigger.js';
import '@elliemae/ds-icons/MoreOptionsVert';
import './rowSizes.js';
import './plugins/pagination/PaginationPlugin.js';
import './plugins/pagination/helper.js';
import './plugins/pagination/usePaginationState.js';
import './components/NoResults.js';
import './plugins/virtualization/VirtualizationPlugin.js';
import './plugins/virtualization/VirtualizedBody.js';
import './plugins/virtualization/VirtualizedBodyRow.js';
import './plugins/virtualization/helper.js';
import './plugins/expandable-grid/ExpandablePlugin.js';
import 'react-window';
import '@elliemae/ds-icons/ArrowheadRight';
import './plugins/expandable-grid/ExpandedRow.js';
import '@elliemae/ds-basic/Separator';
import '@elliemae/ds-shared/defer-render-hoc';
import './plugins/column-sizing/ColumnSizingPlugin.js';
import './plugins/column-sizing/useStylesheetHelpers.js';
import 'stylesheet-helpers';
import './plugins/column-sizing/getColumnNameFromProperty.js';
import './utilities/getScrollbarSize.js';
import './plugins/column-sizing/useColumnSizeService.js';
import './plugins/column-sizing/utils.js';
import './plugins/column-sizing/ext-points/getTableProps.js';
import './plugins/column-sizing/ext-points/decorateColumn.js';
import './plugins/column-sizing/columnMeasurerTransformer.js';
import './components/RowsLoader.js';
import '@elliemae/ds-basic/Spinner';
import './plugins/expandable-grid/ExpandedRowExtra.js';
import './plugins/expandable-grid/useExpandGridState.js';
import '@elliemae/ds-utilities/hooks/useExpandState';
import './plugins/grouping-grid/GroupingPlugin.js';
import './plugins/grouping-grid/walkStrategy.js';
import './plugins/grouping-by/GroupingByPlugin.js';
import './plugins/body-header-scroll-sync/BodyHeaderScrollSyncPlugin.js';
import '@elliemae/ds-shared/ScrollSync';
import './plugins/resizable/ResizablePlugin.js';
import './plugins/resizable/decorateResizable.js';
import './plugins/resizable/useResizeHandle.js';
import './plugins/custom-cell-renderer/CustomRendererPlugin.js';
import './plugins/custom-cell-renderer/addCustomRendererToCell.js';
import './plugins/custom-cell-renderer/getRendererComponent.js';
import '@elliemae/ds-basic/form/Toggle';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var isFluid = function isFluid(_ref) {
  var autoHeight = _ref.autoHeight,
      paginated = _ref.paginated,
      numRowsVisible = _ref.numRowsVisible;
  if (autoHeight) return false;
  if (paginated) return false;
  return !numRowsVisible;
};

function DataGridImpl(_ref2) {
  var className = _ref2.className;
      _ref2.renderers;
      var columns = _ref2.columns,
      rows = _ref2.rows,
      containerProps = _ref2.containerProps,
      pluginsProp = _ref2.plugins,
      normalizeDataKeys = _ref2.normalizeDataKeys,
      otherProps = _objectWithoutProperties(_ref2, ["className", "renderers", "columns", "rows", "containerProps", "plugins", "normalizeDataKeys"]);

  var _otherProps$noResults = otherProps.noResultsPlaceholder,
      noResultsPlaceholder = _otherProps$noResults === void 0 ? /*#__PURE__*/React.createElement(EmptyState, null) : _otherProps$noResults,
      _otherProps$noColumns = otherProps.noColumnsPlaceholder,
      noColumnsPlaceholder = _otherProps$noColumns === void 0 ? 'Please select one of more columns in order for data to be displayed.' : _otherProps$noColumns,
      noResultsRender = otherProps.noResultsRender,
      paginated = otherProps.paginated,
      height = otherProps.height,
      showHeader = otherProps.showHeader,
      showRowsLoader = otherProps.showRowsLoader,
      _otherProps$rowsLoade = otherProps.rowsLoaderRenderer,
      rowsLoaderRenderer = _otherProps$rowsLoade === void 0 ? renderRowsLoader : _otherProps$rowsLoade,
      groupedRows = otherProps.groupedRows,
      sortable = otherProps.sortable,
      rowSize = otherProps.rowSize,
      wrapText = otherProps.wrapText,
      onDefaultFiltersLoad = otherProps.onDefaultFiltersLoad;
  var plugins = getPluginsFromProps(_objectSpread(_objectSpread({}, otherProps), {}, {
    virtualized: (!paginated || groupedRows) && !wrapText,
    paginated: paginated && !groupedRows || wrapText,
    sortable: sortable && !groupedRows
  }));

  if (normalizeDataKeys) {
    normalizeRows(rows);
  }

  var grid = useDataGrid(_objectSpread({
    columns: columns,
    rows: rows,
    renderers: defaultRenderers,
    plugins: [].concat(_toConsumableArray(plugins), _toConsumableArray(pluginsProp), _toConsumableArray(defaultPlugins))
  }, otherProps));
  var noColumnsVisible = useMemo(function () {
    var visibleUserColumns = grid.columns.filter(function (column) {
      return column.visible || typeof column.visible === 'undefined';
    });
    return visibleUserColumns.length === 0;
  }, [grid.columns]);
  var bodyPlaceholder = useMemo(function () {
    if (noColumnsVisible) {
      return noColumnsPlaceholder;
    }

    return isFunction(noResultsRender) ? noResultsRender() : noResultsPlaceholder;
  }, [noResultsPlaceholder, noColumnsPlaceholder, noColumnsVisible]);
  var pagination = otherProps.pagination;
  var conditionalPagination = pagination && pagination.conditionalPagination === true && rows.length <= otherProps.pagination.perPage;
  var usePagination = paginated && !conditionalPagination;
  return /*#__PURE__*/React.createElement(DatagridWrapper, _extends({
    className: "".concat(className, " ds-row-size-").concat(rowSize),
    classProps: {
      fluidHeight: isFluid({
        autoHeight: otherProps.autoHeight,
        numRowsVisible: otherProps.numRowsVisible,
        paginated: usePagination
      })
    },
    style: {
      height: height
    }
  }, containerProps), addOptionalHeaderComponents({
    grid: grid
  }), /*#__PURE__*/React.createElement(Table, _extends({}, grid, {
    onDefaultFiltersLoad: onDefaultFiltersLoad
  }), showHeader && /*#__PURE__*/React.createElement(TableHeader, null), showRowsLoader ? rowsLoaderRenderer() : /*#__PURE__*/React.createElement(TableBody, {
    isPlaceholderActive: noColumnsVisible || grid.composedRows.rows && grid.composedRows.rows.length === 0 || grid.composedRows.length === 0,
    noResultsPlaceholder: bodyPlaceholder
  })), addOptionalFooterComponents({
    grid: grid,
    rows: grid.composedRows
  }));
}

export default DataGridImpl;
//# sourceMappingURL=DataGridImpl.js.map
